<div *ngIf="propShares.length > 0; else noShare">
  <app-share-table
    [shares]="propShares"
    [curProp]="prop"
    [modeMyShares]="true"
    [canUpdateShares]="canUpdateProperty"
    [showPropertyName]="false"
    [showAddButton]="false"
    [showIncreaseViewTooltip]="canViewIncreaseTooltip"
    (sharesUpdated)="loadData()"
  ></app-share-table>
</div>
<ng-template #noShare>
  <span class="no-content">Aucun accès n'est défini pour cette propriété</span>
  <div *ngIf="canAddShare" class="text-center">
    <p class="mt-5 text-white">
      Partagez les données de cette propriété en cliquant sur
    </p>
    <p>
      <button
        class="mt-2 white"
        mat-mini-fab
        color="primary"
        (click)="addShare()"
      >
        <mat-icon>add</mat-icon>
      </button>
    </p>
  </div>
  <div *ngIf="!canAddShare && canUpdateProperty" class="text-center">
    <p class="mt-5 text-white">
      Pour pouvoir partager ce bien, il doit être certifié.
    </p>
  </div>
</ng-template>
